import React from "react";

type CommodeProps = {
  colour?: string;
  innerColour?: string;
  width?: number;
  height?: number;
};

export const CommodeIcon: React.FC<CommodeProps> = ({
  colour = "#f8f8f8",
  innerColour = "#f2f2f2",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Commode Icon</title>

      {/* Seat outline */}
      <ellipse
        cx="50"
        cy="55"
        rx="30"
        ry="40"
        fill={colour}
        stroke="black"
        strokeWidth="2"
      />

      {/* Inner bowl */}
      <ellipse
        cx="50"
        cy="55"
        rx="20"
        ry="30"
        fill={innerColour}
        stroke="black"
        strokeWidth="2"
      />

      {/* Flush tank */}
      <rect
        x="30"
        y="5"
        width="40"
        height="25"
        fill={colour}
        stroke="black"
        strokeWidth="2"
        rx="5"
      />

      {/* Flush button */}
      <circle cx="50" cy="10" r="3" fill="black" />
    </svg>
  );
};
